import { Popover, styled, useTheme } from "@mui/material";
import React from "react";
import { PopOverProps } from "./types";
import { usePopoverHover } from "./usePopoverHover";

export const PopOver: React.FC<PopOverProps> = ({
  content,
  id,
  triggerComponent,
  className,
  isFixed,
}) => {
  const { isOpen, anchorEl, popoverRef, handleMouseEnter, arrowPosition } =
    usePopoverHover({
      isFixed,
    });
  const theme = useTheme();

  return (
    <>
      <Popover
        id={id}
        open={isOpen}
        anchorReference="anchorEl"
        anchorEl={anchorEl.current}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        marginThreshold={8}
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
        style={{
          marginTop: "-8px",
        }}
        slotProps={{
          paper: {
            ref: popoverRef,
            onMouseEnter: handleMouseEnter,
            sx: {
              overflow: "visible",
              backgroundImage: "none",
              backgroundColor: theme.tokens.colors.gray[4],
              "&:after": {
                content: '""',
                position: "absolute",
                bottom: "-8px",
                left: arrowPosition,
                transform: "translateX(-50%)",
                width: "16px",
                height: "8px",
                backgroundColor: theme.tokens.colors.gray[4],
                boxShadow: theme.shadows[1],
                clipPath: "polygon(0 0, 100% 0, 50% 100%)",
              },
            },
          },
        }}
      >
        <PopOverContentWrapper className={className}>
          {content}
        </PopOverContentWrapper>
      </Popover>
      <div
        ref={anchorEl}
        onMouseEnter={handleMouseEnter}
        className={`${className}-trigger`}
      >
        {triggerComponent}
      </div>
    </>
  );
};

export default PopOver;
const PopOverContentWrapper = styled("div")(() => ({
  padding: "0.5rem 1rem",
}));
